import DashboardTemplate from '@/components/templates/DashboardTemplate';
import { Outlet } from 'react-router-dom';

const AccountingCenterOutlet = () => {
  return (
    <DashboardTemplate>
      <Outlet />
    </DashboardTemplate>
  );
};

export default AccountingCenterOutlet;
